import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CataloguesService } from 'src/app/core/services/catalogues/catalogues.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { allIcons } from './core/consts/allIcons.const';
import { Languages } from './core/model/enum/lang.enum';
import { Keys } from './core/model/enum/localStorage';
import { WebViewService } from './core/services/webview/webview.service';
import * as Sentry from '@sentry/angular';
import { environment } from '../environment';
import { AuthService } from './core/services/auth/auth.service';
import { MessagingService } from './core/services/firebase-messaging/messaging.service';
import { StorageService } from './core/services/storage/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private cataloguesService: CataloguesService,
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
    private readonly webViewService: WebViewService,
    private readonly authService: AuthService,
    private readonly messagingService: MessagingService,
    private readonly storageService: StorageService
  ) {
    Object.keys(allIcons).forEach(iconName => {
      iconRegistry.addSvgIconLiteral(
        iconName,
        sanitizer.bypassSecurityTrustHtml(allIcons[iconName])
      );
    });

    const currentLang = localStorage.getItem(Keys.Language);

    if (currentLang === Languages.KZ || currentLang === Languages.RU) {
      translate.setDefaultLang(currentLang);
      translate.use(currentLang);
    } else {
      translate.setDefaultLang(Languages.KZ);
      translate.use(Languages.KZ);
    }

    localStorage.setItem('activeCourses', '');
  }

  initEruda() {
    if (window.innerWidth <= 999 && !environment.production) {
      import('eruda').then(eruda => eruda.default.init());
    }
  }

  ngOnInit(): void {
    if (environment.production) {
      Sentry.init({
        dsn: 'https://461d3ddc0c25289c9857db778c5c2ab5@o4506851785900032.ingest.us.sentry.io/4509870394114048',
        release: 'v1.0.1',
        sendDefaultPii: true,
        environment: 'production',
        tracesSampleRate: 0.2,
      });
    }

    // Initialize message listener if user is already authenticated
    if (
      this.authService._isAuthenticated$.value &&
      this.storageService.getFcmToken()
    ) {
      this.messagingService.initializeMessageListener();
    }

    this.initEruda();
  }

  ngOnDestroy(): void {
    // Cleanup messaging service listener
    this.messagingService.cleanup();

    if (environment.production) {
      Sentry.init({ enabled: false });
      Sentry.close();
    }
  }
}
